import React from 'react'

export default function TextareaField({
  label,
  id,
  value,
  onChange,
  required = false,
  rows = 3,
  className = '',
  ...props
}) {
  return (
    <div className="space-y-2 w-full">
      <label
        htmlFor={id}
        className="flex items-center text-sm font-medium text-foreground-muted font-inter"
      >
        {label}
        {required && <span className="text-error-900 ml-1">*</span>}
      </label>
      <textarea
        id={id}
        name={id}
        value={value}
        onChange={onChange}
        required={required}
        rows={rows}
        className={`block w-full px-3 py-2 bg-secondary-50 border border-gray-200 rounded-md text-sm font-medium text-foreground font-inter placeholder:text-gray-400 focus:outline-none focus:border-secondary-600 focus:ring-1 focus:ring-secondary-600/20 transition-colors resize-vertical ${className}`}
        {...props}
      />
    </div>
  )
}
